import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useTopPanel from 'hooks/useTopPanel';
import { Box, Tab, Tabs } from '@mui/material';
import DateFilter from 'components/ui/filters/items/DateFilter';
import Offices from './offices';
import Salary from './salary';

export default memo(function Dashboard() {
  const { t, i18n } = useTranslation();
  const { setComponent } = useTopPanel();
  const [tabIndex, setTabIndex] = useState('offices');

  const handleChangeTab = (_, newValue) => {
    setTabIndex(() => newValue);
  };

  useEffect(() => {
    setComponent(
      <div className='component-title flex items-center justify-between gap-5'>
        <div>{t('boss.offices.title')}</div>
        <div>
          <DateFilter label={t('common.fields.date')} />
        </div>
        <div>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
            <Tabs
              value={tabIndex}
              onChange={handleChangeTab}
              type='callsHistory'
            >
              <Tab label={t('boss.offices.tabs.offices')} value={'offices'} />
              <Tab label={t('boss.offices.tabs.salary')} value={'salary'} />
            </Tabs>
          </Box>
        </div>
      </div>
    );
  }, [i18n.language, tabIndex]);

  return (
    <div className='h-full relative'>
      {tabIndex === 'offices' && <Offices />}
      {tabIndex === 'salary' && <Salary />}
    </div>
  );
});
